import { useState, useEffect, useCallback } from "react";
import type { Case } from "@auction-eth/shared-types";
import { api } from "../services/api.js";

interface UseCasesResult {
  cases: Case[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useCases(params?: {
  is_closed?: boolean;
  lender_id?: string;
}): UseCasesResult {
  const [cases, setCases] = useState<Case[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCases = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.cases.list(params);
      setCases(res.data ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unknown error");
    } finally {
      setLoading(false);
    }
  }, [params?.is_closed, params?.lender_id]);

  useEffect(() => {
    void fetchCases();
  }, [fetchCases]);

  return { cases, loading, error, refetch: fetchCases };
}
